module.exports = __webpack_public_path__ + "img/education.d771d643.svg";